import { ProfileSummaryDto } from '../services/socialService';

/** User-facing explanation when a profile cannot be opened. */
export function getProfileViewDeniedMessage(
  aliasName: string,
  summary: ProfileSummaryDto | null | undefined,
): string {
  const handle = aliasName.trim() || 'this user';

  if (!summary) {
    return `@${handle} has not set up a profile yet, or it is not available.`;
  }

  if (summary.canViewProfile) {
    return '';
  }

  if (summary.intVisibilityLevel === 3) {
    return `@${handle} keeps their profile private. Only they can view it.`;
  }

  if (summary.intVisibilityLevel === 2) {
    return `@${handle}'s profile is friends-only. They need to have you in their address book before you can view it.`;
  }

  if (summary.intAliasType === 2) {
    return `@${handle} uses a private alias that does not expose a profile.`;
  }

  return `@${handle}'s profile is not available to you.`;
}

export function canOpenProfileSummary(summary: ProfileSummaryDto | null | undefined): boolean {
  return Boolean(summary?.canViewProfile);
}

/** Tooltip for Find Contact search rows (profile checked when opened). */
export function getSearchResultProfileTooltip(_user: { username: string }): string {
  return 'View profile (availability checked when opened)';
}

/** Location line for Find Contact search rows (account city/state/country). */
export function formatContactSearchLocation(user: {
  chrState?: string;
  chrCountry?: string;
  chrCity?: string;
  chrProfileLocation?: string;
}): string | null {
  const parts: string[] = [];
  if (user.chrCity?.trim()) {
    parts.push(user.chrCity.trim());
  }
  if (user.chrState?.trim()) {
    parts.push(user.chrState.trim());
  }
  if (user.chrCountry?.trim()) {
    parts.push(user.chrCountry.trim());
  }
  return parts.length > 0 ? parts.join(', ') : null;
}
